import React, { useState, useRef, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Drawer,
  Space,
  Button,
  Card,
  Watermark,
  Tabs,
  Tooltip,
  Row,
  Col,
  Flex,
  Avatar,
  Switch,
  Table,
  Radio,
} from "antd";
import { PrinterOutlined, BarsOutlined } from "@ant-design/icons";
import { Watch } from "../Components/Watch";
import { BildUpload } from "../Structur/BildUpload";
import { LayoutData } from "../Structur/Aconlayout";
import { PendingComp } from "../Helper/ProgressComp";
import { HealthCheck } from "../Structur/HealthCheck";
import dayjs from "dayjs";
import Dayjs from "dayjs";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import ReactDOMServer from "react-dom/server";
import { BlobProvider, Document } from "@react-pdf/renderer";
import { useSelector, useDispatch } from "react-redux";
import { pdfSet, pdfClear } from "../Redux/pdfSlice";
import { AvatarClick } from "../Helper/AvatarClick";
import { getJahresliste, JahresListeTabs } from "../Helper/DateTimeHelper";
import { KontenKlassenJahr } from "./KontenKlassenJahr";
import { KontenListe } from "./KontenListe";
import { KontenDatenDetails } from "./KontenDatenDetails";
import { KontenDatenJournal } from "./KontenDatenJournal";
import { IntToBetrag } from "../Helper/ZahlenFormat";
import { getKontoSoll, getKontoHaben } from "../Helper/PrKontoHelper";
import { KontenrahmenPdf } from "./KontenrahmenPdf";

export const Kontenrahmen = () => {
  const {
    checkRole,
    checkRoles,
    setCookie,
    getCookie,
    eventDataPost,
    eventDataDelete,
    getApiBaseUrl,
    apiBaseUrl,
    aktPdfDaten,
    setAktPdfDaten,
    checkMainContainerHeight,
  } = LayoutData();
  const { user, userDaten, windowWidth, aktSumsComponent, logoutLogin } =
    LayoutData();
  const [url1, setUrl1] = useState("");
  const [aktjahr, setAktjahr] = useState(
    window.localStorage.getItem("KontoAktJahr")
  );
  const [aktKlasse, setAktKlasse] = useState(
    parseInt(window.localStorage.getItem("KontoKlasse"))
  );
  const [dataSource, setDataSource] = useState();
  const [druckDataSource, setDruckDataSource] = useState();
  const [kontoData, setKontoData] = useState();
  const [showDrawer1, setShowDrawer1] = useState();
  const [editDrawerCaption1, setEditDrawerCaption1] = useState();
  const [showDrawer2, setShowDrawer2] = useState();
  const [showProfiAuswahl, setShowProfiAuswahl] = useState(false);
  const [editDrawerCaption2, setEditDrawerCaption2] = useState();
  const [nurAktivKonten, setNurAktivKonten] = useState(
    window.localStorage.getItem("nurAktivKonten") === "true"
  );
  const [mitSelektion, setMitSelektion] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [tableArt, setTableArt] = useState(
    parseInt(window.localStorage.getItem("KontoTableArt"))
  );

  useEffect(() => {
    aktSumsComponent(<>Kontenrahmen von PIU-PRINTEX {apiBaseUrl} </>);
    console.log("tableArt", tableArt);
    if (isNaN(tableArt)) setTableArt(1);
    if (isNaN(aktKlasse)) setAktKlasse(0);
  }, []);

  // Es muss immer ein BaseUrl geben
  useEffect(() => {
    if (apiBaseUrl&&aktjahr>0) {
      setUrl1(
        `${apiBaseUrl}profi/getprkont?aktJahr=${aktjahr}&aktKlasse=${aktKlasse}&aktive=${
          nurAktivKonten && "true"
        }`
      );
      window.localStorage.setItem("nurAktivKonten", nurAktivKonten);
    }
  }, [apiBaseUrl, aktjahr, aktKlasse, nurAktivKonten]);

  const {
    isPending: isPending1,
    error: error1,
    data: kontendata,
  } = useQuery({
    queryKey: [url1],
    queryFn: () => {
      if (url1) {
        // Überprüfen, ob url1 definiert ist
        return fetch(url1, {
          headers: {
            Authorization: `Bearer ${user.bearer}`,
          },
        }).then((res) =>  {
          if (res.status === 401) logoutLogin();
          return res.json();
        });
      } else {
        // Wenn url1 nicht definiert ist, gib ein leeres Objekt zurück oder handle den Fall entsprechend
        return Promise.resolve({});
      }
    },
  });
  if (error1) {
    // console.error("XXX Error", error1);
    //logout();
  }

  useEffect(() => {
    if (kontendata && Array.isArray(kontendata)) {
      //console.log("XXX personenData", personenData);
      let newData = [];
      try {
        newData = kontendata.map((item, index) => ({
          ...item,
          key: index,
        }));
      } catch (error) {}
      let summeSoll = 0;
      let summeHaben = 0;
      let bilanzOpen = 0;
      let bilanzClose = 0;
      newData.map((item, index) => {
        bilanzOpen += item.bilanzopen;
        bilanzClose += item.bilanzclose;
        summeSoll += getKontoSoll(item);
        summeHaben += getKontoHaben(item);
        return null;
      });
      let saldo = summeSoll - summeHaben + bilanzClose;
      aktSumsComponent(
        <Flex wrap gap={"small"} style={{ overflow: "auto" }}>
          <div>{kontendata.length} Konten</div>
          <div>Soll: {IntToBetrag(summeSoll)}</div>
          <div>Haben: {IntToBetrag(summeHaben)}</div>
          <div>Saldo: {IntToBetrag(saldo)}</div>
          <div>BilanzOpen: {IntToBetrag(bilanzOpen)}</div>
          <div>BilanzClose: {IntToBetrag(bilanzClose)}</div>
        </Flex>
      );
      //checkMainContainerHeight();
      setDataSource(newData);
    }
  }, [kontendata]);

  const onChangeJahr = (jahr) => {
    //console.log("jahr", jahr);
    setAktjahr(jahr);
  };
  const onChangeKlasse = (key, label) => {
    setAktKlasse(key);
  };
  const onChangeKonto = (daten) => {
    setKontoData(daten);
    setEditDrawerCaption1(
      <>
        {daten.Suchbeg}
        <br />
        <b>{IntToBetrag(daten.konto)}</b>
      </>
    );
    setShowDrawer1(true);
  };
  const onJournalShow = (daten) => {
    //  console.log("onJournalShow daten", daten);
    setKontoData(daten);
    setEditDrawerCaption2(
      <>
        {daten.Suchbeg}
        <br />
        <b>{IntToBetrag(daten.konto)}</b>
      </>
    );
    setShowDrawer2(true);
  };

  const handleDruckBtnClick = () => {
    if (mitSelektion) {
      setDruckDataSource(selectedRows);
    } else setDruckDataSource(dataSource);
    setShowProfiAuswahl(true);

    // console.log(selectedRows);
    // console.log(dataSource);
  };
  const tableTitle = () => (
    <>
      <JahresListeTabs onChange={onChangeJahr} tabPosition={"top"} />
      <KontenKlassenJahr aktjahr={aktjahr} onChange={onChangeKlasse} />
      <Space style={{ color: "lightgray" }}>
        <Button
          icon={<PrinterOutlined style={{ fontSize: 17 }} />}
          onClick={handleDruckBtnClick}
        />
        &nbsp;
        <Switch
          checkedChildren="Alle"
          unCheckedChildren="Aktive"
          checked={nurAktivKonten}
          onChange={() => setNurAktivKonten(!nurAktivKonten)}
        />
        &nbsp;
        <Switch
          checkedChildren="Alle"
          unCheckedChildren="Auswahl"
          checked={mitSelektion}
          onChange={() => setMitSelektion(!mitSelektion)}
        />
        <Radio.Group
          onChange={(e) => {
            // console.log('radio checked', e.target.value);
            window.localStorage.setItem("KontoTableArt", e.target.value);
            setTableArt(e.target.value);
          }}
          value={tableArt}
        >
          <Radio value={1}>A</Radio>
          <Radio value={2}>B</Radio>
          <Radio value={3}>C</Radio>
        </Radio.Group>
        <nobr>Kontendaten</nobr>
      </Space>
    </>
  );

  return (
    <>
      <div className="page">
        <KontenListe
          title={tableTitle}
          dataSource={dataSource}
          aktjahr={aktjahr}
          aktklasse={aktKlasse}
          loading={isPending1}
          onChange={onChangeKonto}
          onJournalShow={onJournalShow}
          mitSelektion={mitSelektion}
          setSelectedRows={setSelectedRows}
          tableArt={tableArt}
        />
        <Drawer
          destroyOnClose
          open={showDrawer1}
          title={editDrawerCaption1 && editDrawerCaption1}
          onClose={() => setShowDrawer1(false)}
          loading={false}
          width={400}
        >
          <KontenDatenDetails kontoData={kontoData} />
        </Drawer>
        <Drawer
          destroyOnClose
          open={showDrawer2}
          title={editDrawerCaption2 && editDrawerCaption2}
          onClose={() => setShowDrawer2(false)}
          placement="left"
          loading={false}
          width={400}
          //style={{ background: '#f0f0f0', padding: '2px' }} //
        >
          <KontenDatenJournal
            kontoData={kontoData}
            setTitel={setEditDrawerCaption2}
          />
        </Drawer>
        <KontenrahmenPdf
          showProfiAuswahl={showProfiAuswahl}
          mitSelektion={mitSelektion}
          setShowProfiAuswahl={setShowProfiAuswahl}
          dataSource={druckDataSource}
          user={user}
          jahr={aktjahr}
          klasse={aktKlasse}
        />
        {/* <PendingComp isPending={isPending1 || isPending1} />*/}
      </div>
    </>
  );
};
